angular.module(NgAppName).component('crCalloutboxSell', {
	templateUrl: 'crCalloutboxSell.html',
	bindings: {
		rpc: '@',
		address: '@',
		buildingPageUrl: '@',
		isMobile: '@',
		totalUnits: '@'
	},
	controller: ['$element', '$window', '$timeout', '$scope', '$location', '$filter' ,'gVariables', 'PubSub', 'crResourcesService', 'StateService', function($element, $window, $timeout, $scope, $location, $filter, gVariables, PubSub, crResourcesService, StateService) {
		var self = this;

		this.onMobile = true;
		this.loaded = false;
		this.recentSales = {};

		this.$onInit = () => { 
			this.loadNbBuyers();
		};

		this.loadNbBuyers = (period) => {
			let url = this.rpc; 
			crResourcesService.get(url).$promise.then((data) => {
				if (data) {
					if (data && data.data) {	
						this.nbBuyers = data.data;
					}

					this.loaded = true;
				}
			});
		};

		this.openSellPopup = () => {
			PubSub.publish('cr-popup-open-popup-sell', null);
		};

	}]
});
